<template>
  <div class="input-group">
    <input-error v-for="(propName, index) in propNames" :errors="errors" :propName="propName" :key="index"></input-error>
    <slot></slot>
  </div>
</template>

<script>
import InputError from './InputError'

export default {
  components: { InputError },
  name: 'input-group',
  props: {
    errors: {
      type: Object,
      default: function () {
        return {}
      }
    },
    propNames: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
</style>



// WEBPACK FOOTER //
// src/components/input/InputGroup.vue